import { Phone } from "lucide-react";
import { SITE } from "@/lib/site";

export default function FloatingEmergencyButton() {
  return (
    <a
      href={SITE.phoneHref}
      className="emergency-fab shake-on-hover group flex items-center gap-3 pl-4 pr-5 py-3.5 md:py-4 md:pl-5 md:pr-6 rounded-full font-extrabold tracking-wider text-sm md:text-[13px] uppercase select-none"
      data-testid="floating-emergency-btn"
      aria-label="Call emergency line"
    >
      <span className="w-9 h-9 md:w-10 md:h-10 grid place-items-center rounded-full bg-white/15 backdrop-blur-sm">
        <Phone className="w-4 h-4 md:w-5 md:h-5 shake-icon" />
      </span>
      <span className="hidden sm:flex flex-col leading-tight">
        <span className="text-[10px] opacity-80 tracking-[0.22em]">24/7 Emergency</span>
        <span className="text-base font-extrabold">{SITE.phone}</span>
      </span>
      <span className="sm:hidden">Call now</span>
    </a>
  );
}
